import { courseApi } from "./index";

export interface StudentsListParams {
  ids?: Array<string>;
  name?: string;
  email?: string;
  snils?: string;
  userIds?: Array<string>;
  belongToContractorId?: string;
  notBelongToContractorId?: string;
  companyId?: string;
  createdAtMin?: Date;
  createdAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "name" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: StudentsListParams, options?: any) => {
  return courseApi.Student.listStudents(
    params.ids,
    params.name,
    params.email,
    params.snils,
    params.userIds,
    params.belongToContractorId,
    params.notBelongToContractorId,
    params.companyId,
    params.createdAtMin,
    params.createdAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    options
  );
};
